import { IoArrowBack } from "react-icons/io5";

import { IAdvisorChoice } from "@types";

import { cn } from "./cn";

/** The choice chips for the latest turn, plus a lighter-weight "back" link if one was offered. */
export function AdvisorChoices({
  choices,
  onSelect,
}: {
  choices: IAdvisorChoice[];
  onSelect: (choice: IAdvisorChoice) => void;
}) {
  const forward = choices.filter(choice => choice.choice_id !== "BACK");
  const back = choices.find(choice => choice.choice_id === "BACK");

  return (
    <div className="mt-4 flex flex-col gap-2">
      <div className="flex flex-col items-start gap-2">
        {forward.map(choice => (
          <button
            key={choice.choice_id}
            type="button"
            onClick={() => onSelect(choice)}
            className={cn(
              "whitespace-normal rounded-full border px-4 py-2 text-left text-sm font-medium leading-snug transition-colors",
              choice.recommended
                ? "border-revampBlue bg-revampBlue text-white hover:bg-revampDarkBlue"
                : "border-gray-200 bg-white text-gray-800 hover:bg-gray-100"
            )}
          >
            {choice.label}
          </button>
        ))}
      </div>
      {back && (
        // Back is a real server-side transition, not browser history — but it's a step
        // backwards, so it reads as secondary.
        <button
          type="button"
          onClick={() => onSelect(back)}
          className="inline-flex w-fit items-center gap-1.5 rounded-lg py-1 text-xs font-medium text-gray-500 transition-colors hover:text-gray-800"
        >
          <IoArrowBack className="h-3.5 w-3.5" />
          {back.label}
        </button>
      )}
    </div>
  );
}
